import styled from 'styled-components';

export const ButtonAndDisclaimerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;
